export default __webpack_public_path__ + "images/I0.27b6cba.png";